import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Typography, SvgIcon } from '@mui/material';
import customColor from '../../styles/mui/szPaletteOverrides.json'
import custom from '../../styles/mui/szVariables.json'

type ChartItem = {
  id: string;
  label: string;
  value: number;
};

const EnergyConsumptionChart = ({ chart, solarIconPath, rightPanel }: 
    { chart: ChartItem[], solarIconPath: React.ReactNode, rightPanel: any }) => 
  {
  const colors: any = {
    consumed: customColor.palette.primary.main,
    exported: customColor.palette.grid.main
  };

  const data = (chart || []).map(item => ({
    ...item,
    color: colors[item.id] 
  }));

  return (
    <Box flexDirection={{
        xs:"column-reverse",
        sm:"column-reverse",
        md:rightPanel?"column-reverse":"row",
        lg:"row"
      }}  
      sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          width: '320px'
        }}
      >
      <Box
        sx={{
          display: 'flex',
          flexDirection: {
            xs: 'column',
            sm: rightPanel?'column':'row',
            md: 'column',
            lg: 'column',
          },
          justifyContent: 'center',
          alignItems: 'flex-start',
          mr: custom.spacing.sm,
          mt: custom.spacing.sm,
        }}
      >
        {(data || []).map((item) => (
          <Box key={item.id} sx={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: {
              xs: 'flex-start',
              sm: rightPanel?'flex-start':'center',
              md: 'flex-start',
              lg: 'flex-start',
            },
            width: '150px'
            }}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor: item.color,
                mr: custom.spacing.xxs,
              }}
            />
            <Typography variant="szBody.Regular.xSmall"
              id={item.id}>
              {item.label} {item.value}%
            </Typography>
          </Box>
        ))}
      </Box>
      <Box id="energyConsumptionChart" 
        sx={{ position: 'relative', width: 160, height: 160 }}>
        <PieChart
          series={[
            {
              data,
              innerRadius: 40,
              outerRadius: 80,
              paddingAngle: 1,
              startAngle: -90,
              endAngle: 270,
              cx: 75,
              cy: 75,
              valueFormatter: (val: any)=> `${val.value}%`,
            },
          ]}
          slotProps={{
            legend: { hidden: true },
          }}
          width={160}
          height={160}
          tooltip={{ trigger: 'none' }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '51%',
            left: '51%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          <SvgIcon sx={{width: '120px', height: '30px'}}>{solarIconPath}</SvgIcon>
        </Box>
      </Box>
    </Box>
  );
};

export default EnergyConsumptionChart;